"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, props.answers && props.answers.map(function (answer) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        border: '1px solid black'
      },
      onClick: props.onAnswer
    }, answer);
  })), /*#__PURE__*/_react["default"].createElement("div", null, props.children));
}